import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useUserData } from '../hooks';
import styles from './Sidebar.module.css';

const Sidebar = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isBrokerOwner } = useUserData();

  const menuSections = [
    {
      id: 'search',
      items: [
        {
          id: 'mls-gpt',
          title: 'MLS GPT',
          subtitle: 'Chat with MLS',
          path: '/app/mls-gpt',
          icon: '🤖'
        },
        {
          id: 'cma-from-scratch',
          title: 'CMA from Scratch',
          subtitle: 'Create CMA from Any Address',
          path: '/app/cma-from-scratch',
          icon: '📊'
        },
        {
          id: 'tax-record-search',
          title: 'Tax Record Search',
          subtitle: 'Search Property Tax Records',
          path: '/app/tax-record-search',
          icon: '📋'
        },
        {
          id: 'coordinate-search',
          title: 'Find by Coordinates',
          subtitle: 'Locate a Property by GPS',
          path: '/app/coordinate-search',
          icon: '📍'
        },
      ],
    },
    {
      id: 'media',
      label: 'Photo & Video',
      items: [
        {
          id: 'virtual-staging',
          title: 'Virtual Staging',
          subtitle: 'AI-Stage Property Photos',
          path: '/app/virtual-staging',
          icon: '🛋️'
        },
        {
          id: 'video-montage',
          title: 'Video Montage',
          subtitle: 'Cinematic Slideshow Video',
          path: '/app/video-montage',
          icon: '🎬'
        },
      ],
    },
    {
      id: 'account',
      items: [
        {
          id: 'dashboard',
          title: 'Dashboard',
          subtitle: 'Overview & Quick Actions',
          path: '/app/dashboard',
          icon: '🏠'
        },
        ...(isBrokerOwner ? [{
          id: 'broker-dashboard',
          title: 'Broker Dashboard',
          subtitle: 'Team Billing & Usage',
          path: '/app/broker',
          icon: '🧾'
        }] : []),
      ],
    },
  ];

  const isActive = (path) => {
    if (path === '/app/dashboard') {
      return location.pathname === '/app' || location.pathname === '/app/' || location.pathname === '/app/dashboard';
    }
    return location.pathname.startsWith(path);
  };

  const handleItemClick = (path) => {
    navigate(path);
    // Close sidebar on mobile after navigation
    if (window.innerWidth <= 768 && onClose) {
      onClose();
    }
  };

  return (
    <>
      {/* Overlay for mobile */}
      {isOpen && (
        <div
          className={`${styles.sidebarOverlay} ${isOpen ? styles.sidebarOverlayActive : ''}`}
          onClick={onClose}
          aria-label="Close sidebar"
        />
      )}

      {/* Sidebar */}
      <div className={`${styles.sidebar} ${isOpen ? styles.sidebarOpen : ''}`}>
        {/* Navigation Menu */}
        <nav className={styles.sidebarNav}>
          {menuSections.map((section) => (
            <div key={section.id} className={styles.sidebarSection}>
              {section.label && (
                <div className={styles.sidebarSectionLabel}>{section.label}</div>
              )}
              {section.items.map((item) => (
                <div
                  key={item.id}
                  onClick={() => handleItemClick(item.path)}
                  className={`${styles.sidebarItem} ${isActive(item.path) ? styles.sidebarItemActive : ''}`}
                >
                  <div className={styles.sidebarItemContent}>
                    <span className={styles.sidebarIcon}>
                      {item.icon}
                    </span>
                    <div className={styles.sidebarText}>
                      <div className={styles.sidebarTitle}>
                        {item.title}
                      </div>
                      <div className={styles.sidebarSubtitle}>
                        {item.subtitle}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </nav>
      </div>
    </>
  );
};

export default Sidebar; 